import digitalData from 'digital-data';
import {
  APPLIANCE_FUEL_TYPE_DRAWER,
  OVERLAY
} from '../constants';

export const applianecFuelType = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('appliance-fuel-type-drawer.click', () => {
    const ddoEvent = {
      category: {
        primaryCategory: OVERLAY
      },
      eventInfo: {
        eventName: APPLIANCE_FUEL_TYPE_DRAWER
      }
    };
    digitalData.event = digitalData.event || [];
    digitalData.event.push(ddoEvent);
  });
};
